import { ModelConfigParams, genericApplicationChecklistMFG, genericApplicationChecklistQC } from "./model-config-params";

export const knee: ModelConfigParams = {
  bodyParts: [
    'artery',
    'vein',
    'bone',
    'nerve',
    'slam',
    'muscleLeftRight',
    'cartilage',
  ],
  checklist: genericApplicationChecklistMFG,
  checklistQC: genericApplicationChecklistQC,
  defaultIntensityRange: [0, 3000],
  internal: true,
}
